import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { SecureAccessHub, useSecureAccess, SECURE_ACCESS_CREATE_ROOT, secureAccessDetailPath } from './olivium/secure-access'
import { OLV_SUITE_ROOT } from './olivium/governance/governanceCards'

/**
 * Olivium Secure Access hub — route wrapper (PHASE_2L).
 *   /square/command-center/olivium/secure-access
 *
 * Reuses the real, admin-gated sq_access_codes spine via useSecureAccess
 * (api.commandCenter.access). Honest auth/forbidden/error states; no fake codes.
 */
export default function SquareCodeSecureAccessRoute() {
  const navigate = useNavigate()
  const s = useSecureAccess()
  return (
    <SecureAccessHub
      codes={s.codes}
      summary={s.summary}
      loading={s.loading}
      error={s.error}
      authRequired={s.authRequired}
      forbidden={s.forbidden}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onBackToSuite={() => navigate(OLV_SUITE_ROOT)}
      onCreate={() => navigate(SECURE_ACCESS_CREATE_ROOT)}
      onOpenCode={(id) => navigate(secureAccessDetailPath(id))}
    />
  )
}
